import React from 'react';

const Students = () => {
  return (
    <div>
      Students
      Students
    </div>
  );
}

export default Students;
